var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarList = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 17,
  viewBox: "0 0 14 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.6875 4.13622L9.80638 0.379499C9.57039 0.149886 9.24829 0.0191344 8.91663 0.0191344L1.60729 0C0.720729 0 0 0.714351 0 1.59453V14.7271C0 15.5913 0.743052 16.3248 1.62323 16.3248H12.4342C13.2984 16.3248 14 15.6073 14 14.7239V4.89841C14 4.60182 13.8884 4.33075 13.6875 4.13622ZM9.79043 2.13986L11.7964 4.07882H10.138C9.95308 4.07882 9.79043 3.93531 9.79043 3.77267V2.13986ZM12.4342 15.0492H1.62323C1.44465 15.0492 1.27563 14.8929 1.27563 14.7239V1.59453C1.27563 1.42551 1.43189 1.27563 1.60729 1.27563L8.51481 1.29476V3.77267C8.51481 4.64328 9.24191 5.35444 10.138 5.35444H12.7244V14.7239C12.7244 14.8834 12.6159 15.0492 12.4342 15.0492Z",
  fill: "#7A757F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.77441 8.51162C2.77441 8.86242 3.06143 9.14944 3.41223 9.14944H8.99309C9.34389 9.14944 9.63091 8.86242 9.63091 8.51162C9.63091 8.16083 9.34389 7.87381 8.99309 7.87381H3.41223C3.06143 7.87381 2.77441 8.16083 2.77441 8.51162Z",
  fill: "#7A757F"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.38049 6.59817H7.07981C7.4306 6.59817 7.71762 6.31115 7.71762 5.96035C7.71762 5.60956 7.4306 5.32254 7.07981 5.32254H3.38049C3.02969 5.32254 2.74268 5.60956 2.74268 5.96035C2.74268 6.31115 3.02969 6.59817 3.38049 6.59817Z",
  fill: "#7A757F"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5876 10.425H3.41223C3.06143 10.425 2.77441 10.7121 2.77441 11.0629C2.77441 11.4137 3.06143 11.7007 3.41223 11.7007H10.5876C10.9384 11.7007 11.2254 11.4137 11.2254 11.0629C11.2254 10.7121 10.9384 10.425 10.5876 10.425Z",
  fill: "#7A757F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_list.1f9387c55449fb2a45799d54f3138ef7.svg";